import { eventDebounce } from '@Front/utility';
import { DEFAULTS, STATES } from '@Front/components/header/_config';
import Component from '@bythepixel/component-loader';

export default class Header extends Component {
  static selector = `.${DEFAULTS.header}`;

  constructor(containerEl, options = { ...DEFAULTS, ...STATES }) {
    super(containerEl, options);

    this.mount();
  }

  mount() {
    this.header = this.$container;

    document.addEventListener('scroll', eventDebounce(this.handleScroll, 1000 / 60)); // 60hz
  }

  handleScroll = () => {
    const scrollAmount = parseInt(this.header.getAttribute(this.$options.scrollAmount)); // eslint-disable-line
    const scrollDirection = window.scrollY <= scrollAmount ? 'up' : 'down';
    const hasScrolledToTop = window.scrollY === 0;
    const hasScrolledPastHeader = window.scrollY > this.header.offsetHeight;

    this.header.setAttribute(this.$options.scrollAmount, window.scrollY);

    if (hasScrolledToTop || !hasScrolledPastHeader) {
      this.header.removeAttribute(this.$options.state);
      return;
    }

    this.header.setAttribute(this.$options.state, scrollDirection === 'down' ? this.$options.scrolled : this.$options.visible);
  };
}
